import React, { Suspense } from 'react'
import { Spinner, Flex } from '@chakra-ui/react'

const FailBack = ({ component: Component }: any) => {
  return (
    <Suspense
      fallback={
        <Flex
          alignItems="center"
          justifyContent="center"
          pos="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bgColor="gray.850"
          zIndex="tooltip"
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Flex>
      }
    >
      <Component />
    </Suspense>
  )
}

export default FailBack
